// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-profile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
}

.subscription-profile-header h1 {
    font-size: 24px;
    font-weight: 600;
    color: #202124;
    margin: 0;
}

.subscription-profile-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 30px;
}

.status-section,
.location-section,
.token-section,
.session-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
}

.status-badge {
    margin: 12px 0;
}

.token-display {
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 12px;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.token-display code {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    color: #202124;
    word-break: break-all;
    flex: 1 1;
}

.link-button {
    background: transparent;
    border: 1px solid #4346ce;
    color: #4346ce;
    padding: 4px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    margin-left: auto;
    transition: all 0.2s;
}

.link-button:hover {
    background: #f0f0ff;
}

.notification-history {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 1px solid #e0e0e0;
}

@media (max-width: 1024px) {
    .subscription-profile-content {
        grid-template-columns: 1fr;
    }
}

/* Activity Timeline Styles */
.activity-timeline {
    margin-top: 20px;
}

.activity-item {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    margin-bottom: 12px;
    overflow: hidden;
    transition: all 0.2s;
}

.activity-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.activity-item-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    background: white;
    transition: background 0.2s;
}

.activity-item-header:hover {
    background: #f8f9fa;
}

.activity-timestamp {
    font-size: 13px;
    color: #5f6368;
    min-width: 180px;
}

.activity-status {
    font-size: 14px;
    color: #202124;
    font-weight: 500;
    flex: 1 1;
}

.activity-details {
    padding: 16px 20px;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
}

.activity-details h4 {
    font-size: 14px;
    font-weight: 600;
    color: #202124;
    margin-bottom: 16px;
}

.activity-detail-row {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #e8eaed;
    font-size: 13px;
}

.activity-detail-row:last-child {
    border-bottom: none;
}

.detail-label {
    color: #5f6368;
    min-width: 140px;
    font-weight: 500;
}

.detail-value {
    color: #202124;
    flex: 1 1;
    word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/users/SubscriptionProfile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;;;IAII,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,SAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAO;IACP,sBAAsB;AAC1B","sourcesContent":[".subscription-profile-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.subscription-profile-header h1 {\n    font-size: 24px;\n    font-weight: 600;\n    color: #202124;\n    margin: 0;\n}\n\n.subscription-profile-content {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    gap: 30px;\n}\n\n.status-section,\n.location-section,\n.token-section,\n.session-section {\n    margin-top: 30px;\n    padding-top: 20px;\n    border-top: 1px solid #e0e0e0;\n}\n\n.status-badge {\n    margin: 12px 0;\n}\n\n.token-display {\n    background: #f8f9fa;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 12px;\n    margin-top: 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n}\n\n.token-display code {\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n    color: #202124;\n    word-break: break-all;\n    flex: 1;\n}\n\n.link-button {\n    background: transparent;\n    border: 1px solid #4346ce;\n    color: #4346ce;\n    padding: 4px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    margin-left: auto;\n    transition: all 0.2s;\n}\n\n.link-button:hover {\n    background: #f0f0ff;\n}\n\n.notification-history {\n    margin-top: 40px;\n    padding-top: 30px;\n    border-top: 1px solid #e0e0e0;\n}\n\n@media (max-width: 1024px) {\n    .subscription-profile-content {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Activity Timeline Styles */\n.activity-timeline {\n    margin-top: 20px;\n}\n\n.activity-item {\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    margin-bottom: 12px;\n    overflow: hidden;\n    transition: all 0.2s;\n}\n\n.activity-item:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.activity-item-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 16px;\n    background: white;\n    transition: background 0.2s;\n}\n\n.activity-item-header:hover {\n    background: #f8f9fa;\n}\n\n.activity-timestamp {\n    font-size: 13px;\n    color: #5f6368;\n    min-width: 180px;\n}\n\n.activity-status {\n    font-size: 14px;\n    color: #202124;\n    font-weight: 500;\n    flex: 1;\n}\n\n.activity-details {\n    padding: 16px 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #e0e0e0;\n}\n\n.activity-details h4 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #202124;\n    margin-bottom: 16px;\n}\n\n.activity-detail-row {\n    display: flex;\n    padding: 10px 0;\n    border-bottom: 1px solid #e8eaed;\n    font-size: 13px;\n}\n\n.activity-detail-row:last-child {\n    border-bottom: none;\n}\n\n.detail-label {\n    color: #5f6368;\n    min-width: 140px;\n    font-weight: 500;\n}\n\n.detail-value {\n    color: #202124;\n    flex: 1;\n    word-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
